import React, {
  useState,
  useEffect,
  createContext,
  useContext,
  useCallback,
} from "react";
import {
  GetUser,
  signIn as sendSignInRequest,
  callQueryable,
  logout
} from "../api/auth";

function AuthProvider(props) {
  const [user, setUser] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async function () {
      const result = await GetUser();
      if (result.isOk) {
        setUser(result.data);
      }

      setLoading(false);
    })();
  }, []);

  const signIn = useCallback(async (UserName, StoredPassword, employeeOid) => {
    if (!employeeOid) {
      const result = await sendSignInRequest(UserName, StoredPassword);
      if (result.isOk) {
        const data = await GetUser(result.data);
        setUser(data.data);
      }

      return result;
    }
    const result = await callQueryable({
      UserName,
      StoredPassword: StoredPassword + "@123",
      employeeOid,
    });
    const data = await GetUser(result.data.token);
    setUser(data.data);
    window.location.reload();
  }, []);

  const signOut = useCallback(() => {
    logout();
    localStorage.removeItem("token");
    localStorage.removeItem("multiLang");
    localStorage.removeItem("NavigationOid");
    localStorage.removeItem("RoleDetail");
    localStorage.removeItem("NavigationItemCode");
    // localStorage.clear();
    setUser();
  }, []);

  return (
    <AuthContext.Provider
      value={{ user, signIn, signOut, loading }}
      {...props}
    />
  );
}

const AuthContext = createContext({});
const useAuth = () => useContext(AuthContext);

export { AuthProvider, useAuth };
